(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
var fullVideo = new Boulies.PopupModal({
    container: '.bt31-fvContainer',
    background: '.bt31-fvBg',
    content: '.bt31-fvContent',
    openBTN: '.bt31-fvOpen',
    closeBTN: '.bt31-fvClose',
    beforeClose: function(){
        document.querySelector('#bt31-fullCollectionVideo').pause();
    }
})
fullVideo.initModal();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--campaign-popup"]) return;
  try {
    
  (function () {
    var cooldown = 24 * 60 * 60 * 1000;
    function init(root) {
      if (root.campaignCleanup) return;
      var dialog = root.querySelector('dialog');
      var section = root.closest('.shopify-section');
      var action = root.querySelector('.campaign-popup__button');
      var editor = window.Shopify && Shopify.designMode;
      var key = 'boulies_campaign:' + encodeURIComponent(root.dataset.campaign.trim());
      var timer, closeTimer, previousFocus;
      var memory = {};
      function readState() {
        var value;
        try { value = localStorage.getItem(key); } catch (error) { /* Try the cookie fallback. */ }
        if (!value) {
          var cookie = document.cookie.split('; ').find(function (item) { return item.indexOf(key + '=') === 0; });
          if (cookie) {
            try { value = decodeURIComponent(cookie.slice(key.length + 1)); } catch (error) { /* Ignore invalid cookies. */ }
          }
        }
        try { return JSON.parse(value) || memory; } catch (error) { return memory; }
      }
      function saveState(state) {
        memory = state;
        try { localStorage.setItem(key, JSON.stringify(state)); } catch (error) {
          document.cookie = key + '=' + encodeURIComponent(JSON.stringify(state)) + '; path=/; max-age=' + (state.visited ? 31536000 : 86400) + '; SameSite=Lax';
        }
      }
      function suppressed() {
        var state = readState();
        return state.visited || (Number(state.shownAt) > 0 && Date.now() - Number(state.shownAt) < cooldown);
      }
      function isDestination() {
        if (!action) return false;
        var target = new URL(action.href, location.href);
        return target.origin === location.origin && target.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
      }
      function otherDialogOpen() {
        return Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"], dialog[open]')).some(function (el) {
          return el !== dialog && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
        });
      }
      function open() {
        clearTimeout(closeTimer);
        if (!dialog.open) {
          previousFocus = document.activeElement;
          dialog.showModal();
        }
        void dialog.offsetWidth;
        dialog.classList.add('is-open');
      }
      function close(immediate) {
        clearTimeout(closeTimer);
        dialog.classList.remove('is-open');
        function finish() {
          dialog.close();
          if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
        }
        if (immediate) finish();
        else closeTimer = setTimeout(finish, 300);
      }
      root.querySelector('.campaign-popup__close').addEventListener('click', function () { close(false); });
      root.querySelector('.campaign-popup__later').addEventListener('click', function () { close(false); });
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(false); });
      dialog.addEventListener('click', function (event) {
        var rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close(false);
      });
      if (action) action.addEventListener('click', function () {
        if (!editor) saveState({ visited: true, shownAt: Date.now() });
        close(false);
      });
      function select(event) { if (event.target === section) open(); }
      function deselect(event) { if (event.target === section) close(true); }
      document.addEventListener('shopify:section:select', select);
      document.addEventListener('shopify:section:deselect', deselect);
      root.campaignCleanup = function () {
        clearTimeout(timer);
        clearTimeout(closeTimer);
        if (dialog.open) close(true);
        document.removeEventListener('shopify:section:select', select);
        document.removeEventListener('shopify:section:deselect', deselect);
      };
      if (!editor && root.dataset.enabled === 'true' && root.dataset.campaign.trim() && action && !suppressed() && !isDestination()) {
        var attempts = 0;
        var clearSince = Date.now();
        function attempt() {
          if (!root.isConnected || suppressed()) return;
          // Allow three quiet seconds after another dialog closes; never stack on the newsletter.
          if (document.hidden || otherDialogOpen()) clearSince = Date.now();
          if (Date.now() - clearSince < 3000) {
            if (++attempts < 120) timer = setTimeout(attempt, 500);
            return;
          }
          open();
          saveState({ shownAt: Date.now() });
        }
        timer = setTimeout(attempt, 3000);
      }
    }
    function initAll(scope) { scope.querySelectorAll('.campaign-popup').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    else initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.campaign-popup').forEach(function (root) { if (root.campaignCleanup) root.campaignCleanup(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--home-pickup-review"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobileAutoplayDelay = 5000;
    var desktopAutoplayDelay = 4000;
    var phoneQuery = window.matchMedia('(max-width: 650px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var maxRetries = 120;
    var quotePause = 500;
    var quoteScrollSpeed = 20;

    function stopQuoteAutoscroll($slider, resetPosition) {
      var runId = Number($slider.data('homePickupReviewQuoteRunId') || 0);
      $slider.data('homePickupReviewQuoteRunId', runId + 1);

      var $quotes = $slider.find('.home-pickup-review__quote');
      $quotes.stop(true).off('.homePickupReviewQuote');

      if (resetPosition) {
        $quotes.each(function () {
          this.scrollTop = 0;
        });
      }
    }

    function animateQuote($quote, direction) {
      var quote = $quote[0];
      var isCurrent = $quote.closest('.slick-slide').hasClass('slick-current');

      if (!quote || !phoneQuery.matches || reducedMotionQuery.matches || document.hidden || !isCurrent) {
        return;
      }

      var maxScroll = quote.scrollHeight - quote.clientHeight;
      if (maxScroll <= 1) return;

      var target = direction === 'down' ? maxScroll : 0;
      var distance = Math.abs(target - quote.scrollTop);
      var duration = Math.max(1200, (distance / quoteScrollSpeed) * 1000);

      $quote.delay(quotePause).animate({ scrollTop: target }, duration, 'linear', function () {
        animateQuote($quote, direction === 'down' ? 'up' : 'down');
      });
    }

    function startCurrentQuoteAutoscroll($slider) {
      stopQuoteAutoscroll($slider, true);

      if (!phoneQuery.matches || reducedMotionQuery.matches || document.hidden) return;

      var runId = Number($slider.data('homePickupReviewQuoteRunId'));

      window.setTimeout(function () {
        if (Number($slider.data('homePickupReviewQuoteRunId')) !== runId) return;

        var $quotes = $slider.find('.slick-current .home-pickup-review__quote');

        $quotes.each(function () {
          var $quote = window.jQuery(this);

          $quote
            .on('pointerdown.homePickupReviewQuote', function () {
              $quote.stop(true);
            })
            .on('pointerup.homePickupReviewQuote pointercancel.homePickupReviewQuote', function () {
              animateQuote($quote, 'down');
            });

          animateQuote($quote, 'down');
        });
      }, 0);
    }

    function syncSliders(scope) {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return false;

      window
        .jQuery(scope)
        .find('.home-pickup-review__grid')
        .each(function () {
          var $slider = window.jQuery(this);
          var reviewCount = $slider.children('.home-pickup-review__card').length;

          if ($slider.hasClass('slick-initialized')) {
            if (reducedMotionQuery.matches) {
              $slider.slick('slickPause');
            } else {
              $slider.slick('slickPlay');
            }
            startCurrentQuoteAutoscroll($slider);
            return;
          }

          $slider
            .off('.homePickupReviewQuote')
            .on(
              'init.homePickupReviewQuote afterChange.homePickupReviewQuote breakpoint.homePickupReviewQuote',
              function () {
                startCurrentQuoteAutoscroll($slider);
              }
            )
            .on('beforeChange.homePickupReviewQuote', function () {
              stopQuoteAutoscroll($slider, true);
            });

          $slider.slick({
            rows: 2,
            slidesPerRow: 2,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: !reducedMotionQuery.matches,
            autoplaySpeed: desktopAutoplayDelay,
            speed: 500,
            arrows: false,
            dots: reviewCount > 4,
            swipe: true,
            draggable: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 901,
                settings: {
                  slidesPerRow: 1,
                  autoplaySpeed: mobileAutoplayDelay,
                  dots: reviewCount > 2,
                },
              },
            ],
          });
        });

      return true;
    }

    function scheduleSync(scope, retryCount) {
      if (syncSliders(scope) || retryCount >= maxRetries) return;

      window.setTimeout(function () {
        scheduleSync(scope, retryCount + 1);
      }, 50);
    }

    function syncPage() {
      scheduleSync(document, 0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncPage);
    } else {
      syncPage();
    }

    document.addEventListener('shopify:section:load', function (event) {
      scheduleSync(event.target, 0);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

      window
        .jQuery(event.target)
        .find('.home-pickup-review__grid')
        .each(function () {
          var $slider = window.jQuery(this);
          stopQuoteAutoscroll($slider, true);
          $slider.off('.homePickupReviewQuote');
          if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
        });
    });

    if (typeof phoneQuery.addEventListener === 'function') {
      phoneQuery.addEventListener('change', syncPage);
      reducedMotionQuery.addEventListener('change', syncPage);
    } else {
      phoneQuery.addListener(syncPage);
      reducedMotionQuery.addListener(syncPage);
    }

    document.addEventListener('visibilitychange', syncPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initNewsletter(root) {
      if (root.dataset.initialized || root.dataset.active !== 'true') return;
      root.dataset.initialized = 'true';
      var find = function (selector) {
        return root.querySelector(selector);
      };
      var entry = find('.newsletter-popbtn');
      var opener = find('.newsletter-popbtn--content-wrap');
      var overlay = find('.newsletter-background');
      var dialog = find('.newsletter-container');
      var signup = find('.newsletter-signup');
      var success = find('.newsletter-success-note');
      var successTitle = success.querySelector('.newsletter-title');
      var form = find('.newsletter-form');
      var email = find('.newsletter-email');
      var submit = find('.newsletter-submit');
      var error = find('.newsletter-error');
      var submitLabel = submit.textContent;
      var cookieOptions = { path: '/', expires: 7 };
      var previousFocus,
        previousOverflow,
        pending = false,
        completed = false,
        timer,
        closeTimer,
        isOpen = false;
      var readCookie = function (name) {
        return $.cookie(name);
      };
      var writeCookie = function (name) {
        $.cookie(name, true, cookieOptions);
      };
      function setVisible(element, visible) {
        clearTimeout(element.newsletterHideTimer);
        if (visible) {
          element.hidden = false;
          // Commit the starting style before transitioning from display:none.
          void element.offsetWidth;
          element.classList.add('newsletter-actived');
        } else {
          element.classList.remove('newsletter-actived');
          element.newsletterHideTimer = setTimeout(function () {
            element.hidden = true;
          }, 350);
        }
      }
      function showEntry() {
        setVisible(entry, true);
      }
      function hideEntry() {
        setVisible(entry, false);
      }
      function focusable() {
        return Array.from(dialog.querySelectorAll('button, a[href], input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && el.getClientRects().length > 0;
        });
      }
      function open() {
        if (isOpen) return;
        clearTimeout(timer);
        clearTimeout(closeTimer);
        if (dialog.hidden) {
          previousFocus = document.activeElement;
          previousOverflow = document.body.style.overflow;
        }
        isOpen = true;
        document.body.style.overflow = 'hidden';
        setVisible(overlay, true);
        setVisible(dialog, true);
        (completed ? successTitle : email).focus({ preventScroll: true });
      }
      function close() {
        if (!isOpen) return;
        isOpen = false;
        setVisible(overlay, false);
        setVisible(dialog, false);
        closeTimer = setTimeout(function () {
          document.body.style.overflow = previousOverflow;
          if (!readCookie('boulies_newsletter')) {
            writeCookie('boulies_newsletter_popup_seen');
            showEntry();
          }
          if (
            previousFocus &&
            previousFocus !== document.body &&
            previousFocus.isConnected &&
            previousFocus.getClientRects().length
          ) {
            previousFocus.focus({ preventScroll: true });
          } else if (!entry.hidden) {
            opener.focus({ preventScroll: true });
          } else {
            var fallback = document.querySelector('main, #MainContent');
            if (fallback) {
              var tabindex = fallback.getAttribute('tabindex');
              fallback.setAttribute('tabindex', '-1');
              fallback.focus({ preventScroll: true });
              if (tabindex === null) fallback.removeAttribute('tabindex');
              else fallback.setAttribute('tabindex', tabindex);
            }
          }
        }, 350);
      }
      opener.addEventListener('click', open);
      find('.newsletter-pop-btn--close').addEventListener('click', function () {
        hideEntry();
        writeCookie('boulies_newsletter');
      });
      overlay.addEventListener('click', close);
      find('.newsletter-close-btn').addEventListener('click', close);
      find('.newsletter-finish').addEventListener('click', close);
      function onKeydown(event) {
        if (!isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
        if (event.key === 'Tab') {
          var items = focusable();
          var first = items[0],
            last = items[items.length - 1];
          if (!first) {
            event.preventDefault();
            dialog.focus();
            return;
          }
          if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
            event.preventDefault();
            first.focus();
          }
        }
      }
      function keepFocus(event) {
        if (isOpen && !dialog.contains(event.target)) (focusable()[0] || dialog).focus();
      }
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('focusin', keepFocus);
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (pending || completed) return;
        error.hidden = true;
        email.value = email.value.trim();
        email.removeAttribute('aria-invalid');
        if (!email.validity.valid) {
          error.textContent = root.dataset.invalidMessage;
          error.hidden = false;
          email.setAttribute('aria-invalid', 'true');
          email.focus();
          return;
        }
        pending = true;
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        submit.textContent = root.dataset.loadingLabel;
        try {
          var response = await $.ajax({
            url: 'https://app.boulies.com/api/subscribe',
            method: 'POST',
            timeout: 20000,
            data: { email: email.value, shop: Shopify.shop },
          });
          if (!root.isConnected) return;
          if (!response || response.code != 200) throw new Error('Subscription failed');
          completed = true;
          writeCookie('boulies_newsletter');
          hideEntry();
          signup.hidden = true;
          success.hidden = false;
          dialog.setAttribute('aria-labelledby', successTitle.id);
          if (isOpen) successTitle.focus({ preventScroll: true });
        } catch (failure) {
          if (root.isConnected) {
            error.textContent = root.dataset.errorMessage;
            error.hidden = false;
          }
        } finally {
          pending = false;
          submit.disabled = false;
          submit.textContent = submitLabel;
          form.removeAttribute('aria-busy');
        }
      });
      if (!readCookie('boulies_newsletter')) {
        if (readCookie('boulies_newsletter_popup_seen')) showEntry();
        else timer = setTimeout(open, 1500);
      }
      root.newsletterCleanup = function () {
        clearTimeout(timer);
        clearTimeout(closeTimer);
        [entry, overlay, dialog].forEach(function (element) {
          clearTimeout(element.newsletterHideTimer);
        });
        if (!dialog.hidden) document.body.style.overflow = previousOverflow;
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('focusin', keepFocus);
      };
    }
    function initAll(scope) {
      scope.querySelectorAll('.newsletter-module').forEach(initNewsletter);
    }
    // Shopify's deferred section bundle runs before common.js installs $.cookie.
    if (document.readyState !== 'complete') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initAll(document);
        },
        { once: true }
      );
      window.addEventListener(
        'load',
        function () {
          initAll(document);
        },
        { once: true }
      );
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.newsletter-module').forEach(function (root) {
        if (root.newsletterCleanup) root.newsletterCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--press-reviews"] && !Shopify.designMode) return;
  try {
    
  $('.press-reviews__list').slick({
  	infinite: false,
  	slidesToShow: 3,
  	slidesToScroll: 1,
  	arrows: false,
  	dots: false,
  	centerMode: false,
  	responsive: [{
  		breakpoint: 651,
  		settings: {
  			dots: true,
  			slidesToShow: 1
  		}
  	}]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var noti_bar = document.querySelector('.top-notify');
  if (noti_bar) {
    if (document.querySelector('.bt5-header').classList.contains('product')) {
      var new_noti_bar = noti_bar.cloneNode(true);
      document.querySelector('.header-notify-bar-wrap').removeChild(noti_bar);
      document.querySelector('.product-notify-bar-wrap').appendChild(new_noti_bar);
      new_noti_bar.style.display = 'flex';
      new_noti_bar.querySelector('.top-notify__close-btn').addEventListener('click', function () {
        new_noti_bar.style.display = 'none';
      });
    } else {
      noti_bar.style.display = 'flex';
      noti_bar.querySelector('.top-notify__close-btn').addEventListener('click', function () {
        noti_bar.style.display = 'none';
      });
    }
  }

  (function () {
    var desktopProductsMenu = document.querySelector('.bt5-products-menu');
    var defaultTabKey = 'chairs';
    var initialActiveTab = desktopProductsMenu
      ? desktopProductsMenu.querySelector('[data-products-menu-tab].is-active')
      : null;
    var initialTabKey = initialActiveTab ? initialActiveTab.getAttribute('data-products-menu-tab') : defaultTabKey;
    var tabs;
    var panels;

    if (!desktopProductsMenu || desktopProductsMenu.dataset.desktopProductsMenuReady === 'true') {
      return;
    }

    tabs = Array.prototype.slice.call(desktopProductsMenu.querySelectorAll('[data-products-menu-tab]'));
    panels = Array.prototype.slice.call(desktopProductsMenu.querySelectorAll('[data-products-menu-panel]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    desktopProductsMenu.dataset.desktopProductsMenuReady = 'true';

    function setActiveProductsTab(tabKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-products-menu-tab') === tabKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-products-menu-panel') === tabKey;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      var tabKey = tab.getAttribute('data-products-menu-tab');
      tab.setAttribute('aria-pressed', tabKey === initialTabKey ? 'true' : 'false');
      tab.addEventListener('mouseenter', function () {
        setActiveProductsTab(tabKey);
      });
      tab.addEventListener('focus', function () {
        setActiveProductsTab(tabKey);
      });
    });

    setActiveProductsTab(initialTabKey);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-index"] && !Shopify.designMode) return;
  try {
    
  var saleWrap = document.getElementById('home-saleBannerWrap');
  var saleCounting = document.getElementById('saleCounting');
  var _startDate = new Date(saleWrap.dataset.start).getTime();
  var _endDate = new Date(saleWrap.dataset.end).getTime();
  var _localDate = new Date().getTime();
  var tow = function (n) {
    return n >= 0 && n < 10 ? '0' + n : '' + n;
  };

  if (_endDate > _localDate && _startDate < _localDate) {
    if (_endDate - _localDate < 432000000) {
      document.getElementById('saleEndDate').style.display = 'block';
      document.querySelector('.bt5-sale-note').style.display = 'none';
      var counting = setInterval(function () {
        var now = new Date().getTime();
        var distance = _endDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        saleCounting.innerHTML =
          '<b>' + tow(days) + '</b>d<b>' + tow(hours) + '</b>h<b>' + tow(minutes) + '</b>m<b>' + tow(seconds) + '</b>s';
        if (distance < 0) {
          clearInterval(counting);
          saleWrap.style.display = 'none';
          if (document.querySelector('.b5-sale-note-bar')) {
            document.querySelector('.b5-sale-note-bar').style.display = 'none';
          }
        }
      }, 1000);
    }
    saleWrap.style.display = 'block';
  } else {
    saleWrap.style.display = 'none';
  }

  } catch(e) { console.error(e); }
})();
})();
